import { render, staticRenderFns } from "./signup-business.vue?vue&type=template&id=f5fc300e&"
import script from "./signup-business.vue?vue&type=script&lang=js&"
export * from "./signup-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports